import moment from "moment";
import React, { useState } from "react";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();
const fmt = require("indian-number-format");

export default function TradeCard({
  item,
  trade_delete,
  reload,
  userType,
  commissionShow,
  dollarShow,
}) {
  const [loading, setLoading] = useState(false);
  const [select, setSelect] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [tpassword, setTpassword] = useState("");

  const col = (children, className = "") => (
    <div className={`${className} ${userType === 1 ? "small" : ""}`}>
      {children}
    </div>
  );

  const OpenEditSuper = () => {
    window.user_id = item.super_id;
    window.openeditSuper();
  };

  const OpenEditMaster = () => {
    window.user_id = item.master_id;
    window.masterModalOpen();
  };

  const OpenEdit = () => {
    window.user_id = item.user_id;
    window.userModalOpen();
  };

  const handleDelete = () => {
    select.push(item.id);
    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      delete_select: select,
      tpassword: tpassword,
      type: "TRADE",
      admin: "1",
    };

    backend.delete(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        toast.success(r.message);
        reload();
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
    <div className="menuContainer addHight small text">
      {col(
        item.script_type === "nse"
          ? "NSE"
          : item.script_type === "mcx"
          ? "MCX"
          : item.script_type === "fo"
          ? "NSE-OPTIONS"
          : item.script_type === "mcx_options"
          ? "MCX-OPTIONS"
          : item.script_type === "nse_cash"
          ? "NSE-EQUITY"
          : item.script_type === "comex_future"
          ? "COMEX"
          : item.script_type === "crypto_future"
          ? "CRYPTO"
          : item.script_type === "forex_future"
          ? "FOREX"
          : item.script_type === "us_stock"
          ? "US-STOCK"
          : item.script_type === "sgx"
          ? "SGX"
          : item.script_type === "index"
          ? "OTHERS"
          : item.script_type === "dgcx"
          ? "DGCX"
          : item.script_type === "ncdex"
          ? "NCDEX"
          : "--",
        "menuExchange small"
      )}
      {userType === 1 &&
        col(
          <div onClick={OpenEditSuper}>
            <div className="user_id">{item.super_username}</div>
          </div>,
          "menuExchange small pointer"
        )}

      {(userType === 1 || userType === 2) &&
        col(
          <div onClick={OpenEditMaster}>
            <div className="user_id">{item.master_username}</div>
          </div>,
          "menuExchange small pointer"
        )}

      {(userType === 1 || userType === 2 || userType === 3 || userType === 5) &&
        col(
          <div onClick={OpenEdit}>
            <div className="user_id">{item.username}</div>
          </div>,
          "menuExchange small pointer"
        )}

      {col(item.symbol, "menuSymbol small")}

      {col(
        item.script_type === "nse_cash"
          ? "EQUITY"
          : moment(item.expiry_date).format("DD-MMM"),
        "menuExpiry small"
      )}

      {col(item.qty, "menuBuyPrice small")}

      {col(
        item.type === "NEW" || item.type === "ADDED"
          ? "--"
          : item.standing_rate,
        "menuBuyQty small"
      )}

      {col(item.rate, "menuBuyQty small")}

      {col(
        item.buy_sell == 0 ? "BUY" : "SELL",
        `menuSellQty small ${item.buy_sell == 0 ? "buytext" : "selltext"}`
      )}

      {col(fmt.format(parseFloat(item.new_deposit).toFixed(2)), "menuSellQty small")}

      {col(fmt.format(parseFloat(item.amount).toFixed(0)), "menuSellQty small")}

      {col(
        item.type,
        `menuSymbol small ${
          item.type === "NEW"
            ? "primarytext"
            : item.type === "ADDED"
            ? "buytext"
            : "selltext"
        }`
      )}

      {userType === 4
        ? commissionShow &&
          col(
            fmt.format(parseFloat(item.brokerage_user_amt).toFixed(2)),
            "menuSellQty small selltext"
          )
        : col(
            fmt.format(parseFloat(item.brokerage_user_amt).toFixed(2)),
            "menuSellQty small selltext"
          )}

      {col(
        fmt.format(parseFloat(item.profit_loss).toFixed(2)),
        `menuOpen small ${item.profit_loss > 0 ? "buytext" : "selltext"}`
      )}

      {col(item.other ?? "-", "menuLtt extraSmall")}

      {col(
        <div className="flex flex-col small items-center justify-center">
          <div className="extraSmall">
            {moment(item.date_created).format("DD-MM-YYYY")}
          </div>
          <div className="small">
            {moment(item.date_created).format("HH:mm:ss")}
          </div>
        </div>,
        "menuLtt"
      )}

      {col(item.trade_duration_minutes, "menuLtt small")}

      {trade_delete === 1 &&
        userType === 1 &&
        col(
          <button
            onClick={() => setDeleteVisible(true)}
            className="dropbtnNavSub small sell white"
          >
            DELETE
          </button>,
          "menuBuyPrice pointer"
        )}

      {deleteVisible && (
        <div
          className="customModalOverlay"
          onClick={() => setDeleteVisible(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Clear Data</h3>
            <p className="customModalWarning">
              This action will delete user <b>{item.username}</b> trade{" "}
              <b>{item.symbol}</b> after backup.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setDeleteVisible(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="dropbtnNavSub white primary"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? "Deleting..." : "Confirm Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
